<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script>
import { loadMantisChat } from '@/utils/tools';
import { mapState } from 'vuex';

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(['userInfo']),
  },
  mounted() {
    if (!(this.$root.ytMini || this.$root.pullNewType === 2)) {
      loadMantisChat(this.userInfo);
    }
    if (this.$root.ytMini || this.$root.pullNewType === 2) {
      document.title = '云图书吧';
    }
  },
};
</script>
